import { usePageContent } from "@/hooks/usePageContent";

const features = [
  {
    icon: "ri-cpu-line",
    title: "HBU Engine",
    desc: "Scores land for Residential vs Commercial vs Retail vs Tourism suitability — using zoning laws, FSI rules, and catchment demographics.",
    badge: "Core Algorithm",
  },
  {
    icon: "ri-line-chart-line",
    title: "Valuation Predictor",
    desc: "Forecasts future appreciation based on upcoming infrastructure projects, metro lines, highway expansions, and smart city zones.",
    badge: "Predictive AI",
  },
  {
    icon: "ri-store-2-line",
    title: "Brand Match Algorithm",
    desc: "Direct integration with expansion plans of Starbucks, Amazon, Shell, Delhivery, and 200+ brands seeking locations across India.",
    badge: "Live Network",
  },
];

export default function AIBrainSection() {
  const { getContent } = usePageContent('homepage');
  const heading = getContent('home-ai-brain-heading') || 'The AI Brain Behind The Deals';

  return (
    <section id="ai-brain" className="py-24 bg-background-100">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-sm text-primary-500 font-medium uppercase tracking-wider mb-3">
            Technology
          </span>
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground-950 mb-4">
            {heading}
          </h2>
          <p className="text-foreground-600">
            We don&apos;t guess. We analyze millions of data points to determine exactly what your land is
            worth and what should be built on it.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="p-8 rounded-2xl card-dark group hover:border-primary-500/40 transition-all duration-300 h-full"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-background-50 border border-primary-500/30 mb-6 group-hover:border-primary-500/60 transition-colors">
                <i className={`${f.icon} text-2xl text-primary-500`} />
              </div>
              <div className="inline-block text-xs font-medium px-3 py-1 rounded-full bg-primary-500/10 text-primary-700 mb-4">
                {f.badge}
              </div>
              <h4 className="font-display font-semibold text-xl text-foreground-950 mb-3">{f.title}</h4>
              <p className="text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        {/* AI visual banner */}
        <div className="mt-12 rounded-2xl overflow-hidden relative h-64 md:h-80">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20futuristic%20AI%20data%20visualization%20with%20glowing%20green%20neural%20network%20nodes%20and%20connections%20on%20deep%20dark%20background%2C%20matrix%20data%20streams%2C%20holographic%20grid%20lines%2C%20property%20map%20overlays%20with%20luminous%20teal%20and%20gold%20accents%2C%20cinematic%20technology%20concept%20art%2C%20highly%20detailed&width=1600&height=600&seq=ai-banner-tech-01&orientation=landscape"
            alt="AI Technology visualization"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-100/90 via-background-100/50 to-background-100/20" />
          <div className="absolute inset-0 flex items-center px-8 md:px-16">
            <div className="max-w-lg">
              <h3 className="text-2xl md:text-3xl font-display font-bold text-foreground-950 mb-3">
                48-Hour AI Feasibility Report
              </h3>
              <p className="text-foreground-600 mb-5">
                Submit your land details and receive a comprehensive AI-generated report covering HBU
                analysis, market comparables, and monetization roadmap.
              </p>
              <button
                onClick={() => {
                  const el = document.querySelector("#contact");
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }}
                className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Request Your Report — ₹4,999
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}